import { useState, useCallback } from "react";

export interface UseConfirmDialogOptions {
  onConfirm: () => void;
}

export const useConfirmDialog = ({ onConfirm }: UseConfirmDialogOptions) => {
  const [open, setOpen] = useState(false);
  const openDialog = useCallback(() => setOpen(true), []);
  const closeDialog = useCallback(() => setOpen(false), []);
  const confirm = useCallback(() => {
    onConfirm();
    closeDialog();
  }, [onConfirm, closeDialog]);

  return {
    open,
    openDialog,
    closeDialog,
    confirm,
  };
};
